import * as React from 'react';
import { ApolloError } from 'apollo-client';
import { Query } from 'react-apollo';

import GET_STUDENT_DATA_QUERY from 'coaching/queries/GetProspectiveStudentOptions.gql';
import {
  GetProspectiveStudentOptions,
  GetProspectiveStudentOptions_coaching_studentFamilyMembers,
} from 'coaching/queries/__generated__/GetProspectiveStudentOptions';
// @ts-ignore

export type Student = GetProspectiveStudentOptions_coaching_studentFamilyMembers;

export type Props = {
  children: (props: {
    students?: Student[];
    subjects?: string[];
    gradeLevels?: string[];
    loading: boolean;
    error?: ApolloError;
  }) => React.ReactNode;
};

export default function GetProspectiveStudentOptionsContainer(props: Props) {
  return (
    <Query<GetProspectiveStudentOptions> query={GET_STUDENT_DATA_QUERY}>
      {({ loading, error, data }) => {
        return props.children({
          students: data?.coaching_studentFamilyMembers,
          subjects: data?.coaching_coachableSubjects?.subjects,
          gradeLevels: data?.coaching_gradeLevels?.gradeLevels,
          loading,
          error,
        });
      }}
    </Query>
  );
}
